import { createReducer, on, createSelector } from '@ngrx/store';
import { login, logout } from './user.actions';

import UserState from './user.types';
import { AppState } from 'src/app/app.module';

export const initialState: UserState = {
  isLoggedIn: false,
};

const _userReducer = createReducer(
  initialState,

  on(login, (state) => {
    return {
      ...state,
      isLoggedIn: true
    }
  }),

  on(logout, (state) => {
    localStorage.removeItem('currentUser');

    return {
      ...state,
      isLoggedIn: false
    }
  }),
);


export const selectUserState = (state: AppState): UserState => state.user;

export const selectIsLoggedIn = createSelector(
  selectUserState,
  (state: UserState) => state.isLoggedIn,
);


export function userReducer(state, action) {
  return _userReducer(state, action);
}
